import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'eye-off-icon',
  templateUrl: './eye-off-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EyeOffIconComponent {}
